module.exports = __webpack_public_path__ + "img/lima.b945eff7.jpg";